import { render } from "./SignUp.vue?vue&type=template&id=6f83b81c&scoped=true"
import script from "./SignUp.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUp.vue?vue&type=script&setup=true&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=6f83b81c&scoped=true&lang=css"
import "./SignUp.vue?vue&type=style&index=1&id=6f83b81c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f83b81c"],['__file',"src/views/SignUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f83b81c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f83b81c', __exports__)) {
    api.reload('6f83b81c', __exports__)
  }
  
  module.hot.accept("./SignUp.vue?vue&type=template&id=6f83b81c&scoped=true", () => {
    api.rerender('6f83b81c', render)
  })

}


export default __exports__